export default {
  ESTADO: 'Bahia',
  SISTEMA: 'SICARF-BA',
  SIGLA_ESTADO: 'BA',
  ORGAO: 'SDA',
  LOGO: 'static/logo-ba.png',
  SHAPE_ESTADO: 'municipiosBahia.json',
  COORDENADAS_ESTADO: [-12.96, -38.51],
  UTILIZA_ARCGIS: false
}



// WEBPACK FOOTER //
// ./src/constants/ba/dadosEstado/geral.js